import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/AnimatedIntro.css';

interface AnimatedIntroProps {
  onComplete: () => void;
}

const AnimatedIntro: React.FC<AnimatedIntroProps> = ({ onComplete }) => {
  const [showContent, setShowContent] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Start the animation sequence
    setShowContent(true);

    // After animations complete, call onComplete
    const timer = setTimeout(() => {
      onComplete();
    }, 6000); // Total animation duration

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className={`animated-intro ${showContent ? 'show' : ''}`}>
      <div className="intro-content">
        <div className="intro-header">
          <h1 className="discover-text">Discover</h1>
          <h1 className="beautiful-text">Beautiful</h1>
          <h1 className="destinations-text">Destinations</h1>
        </div>
        
        <div className="intro-subtext">
          <p>Explore the most amazing places in India</p>
        </div>

        <div className="animated-icons">
          <div className="icon-group">
            <i className="icon monument"></i>
            <span>Historical Sites</span>
          </div>
          <div className="icon-group">
            <i className="icon beach"></i>
            <span>Beaches</span>
          </div>
          <div className="icon-group">
            <i className="icon mountain"></i>
            <span>Mountains</span>
          </div>
        </div>

        <div className="animated-line"></div>
      </div>
    </div>
  );
};

export default AnimatedIntro;